import React from 'react'
import Api from "../../public/api";
import {QuestionCircleOutlined} from '@ant-design/icons';
import {Tooltip} from 'antd';
import Util from "../../public/utils";
import CorpApi from "../../public/corp_api";
import IconQuestion from "../../../iconfont/question";

/**
 * 模板消息的模板选择器
 * 示例 <MsgTemplateSelector
 * appId={''}
 * onChange={this.templateChange}
 * defaultValue={this.state.templateId}/>
 */
class MsgTemplateSelector extends React.Component {

    constructor(props) {
        super(props);
        this.init = this.init.bind(this);
        this.setData = this.setData.bind(this);
        this.selected = this.selected.bind(this);
        this.genTooltipTitle = this.genTooltipTitle.bind(this);
        this.state = {
            data: null,
            selectedId: this.props.defaultValue ? this.props.defaultValue : ''
        }
    }

    componentDidMount() {
        if (this.props.appId) {
            this.init(this.props.appId);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.appId && nextProps.appId !== this.props.appId) {
            this.init(nextProps.appId);
        }
        if (nextProps.defaultValue && nextProps.defaultValue !== this.props.defaultValue) {
            this.setState({
                selectedId: nextProps.defaultValue
            })
        }
    }

    init(appId) {
        if (!Util.isNull(appId) && appId.length > 0) {
            let setData = this.setData;
            CorpApi.getMsgTempolateList(appId, function (data) {
                setData(appId, data.list);
            }, function (error) {
                setData(appId, []);
            })
        }
    }

    setData(appId, data) {
        if (!data) {
            data = [];
        }
        this.setState({
            appId: appId,
            data: data
        });
    }

    selected(index) {
        this.setState({
            selectedId: this.state.data[index].template_id
        });
        if (this.props.onChange) {
            let curr = this.state.data[index];
            curr['appId'] = this.state.appId;
            this.props.onChange(curr);
        }
    }

    genTooltipTitle(value) {
        let str, arr = value.split("\TEMP_MXD_ENTER"), arrData = [];
        arr.map((val, index) => {
            arrData.push(React.createElement("span", "", val),
                React.createElement("br"))

        });
        let p = React.createElement("p", "", arrData);
        return p;
    }

    render() {

        let selectedId = this.state.selectedId;
        let selected = this.selected;
        let genTooltipTitle = this.genTooltipTitle;

        if (this.state.data && this.state.data.length > 0) {
            return <div>
                <a className='text-primary howSelect' href="https://www.yuque.com/docs/share/33fef840-60ab-457a-9ff5-eb55a48cf006?#"
                   target="_blank">如何添加模板？</a>
                <ul className='mxd-msgtemplate-wrap clearfix'>
                    {
                        this.state.data.map(function (temp, i) {
                            return (
                                <li className={"mxd-msgtemplate" + (selectedId == temp.template_id ? ' active' : '')}
                                    onClick={selected.bind(this, i)}>
                                    <label>{temp.title}</label>
                                    <span className="example">
                                    <Tooltip placement="right" title={genTooltipTitle(temp.example)}>
                                        {/*<QuestionCircleOutlined/>*/}
                                        <IconQuestion/>
                                    </Tooltip>
                                </span>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        } else if (this.state.data) {
            return <div style={{textAlign: 'center'}}>
                <p className="mxd-no-msgtemplate">该公众号下还没有添加模板，快点去公众号后台添加模板吧~~</p>
                <a className='text-primary howSelect' href="https://shimo.im/docs/C6g2MwfXSIo7JhEW/read"
                   target="_blank">如何添加模板？</a>
            </div>
        } else {
            return ''
        }
    }
}

export default MsgTemplateSelector